<div class="just-flex">
	<ng-container *ngIf="displayValues?.length > 0">
	</ng-container>

	<a *ngIf="displayValues?.length > 1" class="avatar list-count">
		+{{displayValues.length - 1}}
	</a>
</div>